/* ============================================================
   product-landscape-fabric.js
   Behavior for the one-off landscape fabric PDP test.
   Only handles the new tabbed content area — the buy box above
   it (gallery slider, variant radios, price updates, cart) is
   driven by theme.js via data-section-type="product-template".
   Loaded (deferred) only by sections/product-landscape-fabric.liquid.
   ============================================================ */
(function () {
  var root = document.querySelector('.lf-pdp');
  if (!root) return;

  /* ---------- Tab nav: smooth scroll + scroll-spy ---------- */
  var links = Array.prototype.slice.call(root.querySelectorAll('.lf-tabs__link'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-lf-panel]'));

  function activate(id) {
    links.forEach(function (link) {
      link.classList.toggle('is-active', link.getAttribute('href') === '#' + id);
    });
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
      activate(target.id);
    });
  });

  if ('IntersectionObserver' in window && panels.length) {
    var spy = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    panels.forEach(function (panel) { spy.observe(panel); });
  }
})();
